import React, { useEffect } from 'react';
import { IGetSubCategoriesShort, IGetSubCategoriesArguments } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfoV2 } from 'backend/subcategories';
import FormSelect from 'components/Select/FormSelect';
import style from './SuggestedDishSubCategorySelect.module.scss';

interface IProps {
	setSuggestedDishSubCategory: (value: Nullable<string>) => void;
	selectedSuggestedDishCategory: Nullable<string>;
}

export const SuggestedDishSubCategorySelect: React.FC<IProps> = React.memo(
	({ setSuggestedDishSubCategory, selectedSuggestedDishCategory }) => {
		const { response, loading, refetch, responseError } = useFetchData<
			IGetSubCategoriesShort,
			IGetSubCategoriesArguments
		>(selectedSuggestedDishCategory ? getSubCategoriesShortInfoV2 : null, {
			categoryId: selectedSuggestedDishCategory ? selectedSuggestedDishCategory : '',
		});

		useEffect(() => {
			refetch();
		}, [selectedSuggestedDishCategory]);

		return (
			<FormSelect
				name="selectedSuggestedDishSubCategory"
				label="subcategoryLabel"
				formItemClassName={style.container}
				options={response?.data.subCategories}
				fetchError={responseError}
				loading={loading}
				onRefetch={refetch}
				disabled={!selectedSuggestedDishCategory || loading}
				onChange={setSuggestedDishSubCategory}
				onMouseDown={(e) => e.stopPropagation()}
				onClick={(e) => e.stopPropagation()}
			/>
		);
	},
);
